import { defineStore } from 'pinia';
import api from '@/lib/axios';

export const useNavbarSpmiStore = defineStore('navbarSpmi', {
  state: () => ({
    staticNavItems: []
  }),
  actions: {
    async fetchNavItems() {
      try {
        const response = await api.get('spmi/menuspmi');
        this.staticNavItems = response.data;
      } catch (error) {
        console.error('Failed to fetch navigation items:', error);
      }
    }
  }
});